import React from 'react'
import AppliedJob from '../../components/appliedjob/AppliedJob'

const AppliedJobs = () => {
    return (
        <>
            <AppliedJob />
        </>
    )
}

export default AppliedJobs
